import React, { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import {
  FaClock,
  FaUser,
  FaFolder,
  FaTags,
  FaShareAlt,
  FaArrowUp,
} from "react-icons/fa";
import newsDetails from "../../data/art/newsDetails";
import "../../styles/art/pages/NewsDetailPage.css";

function NewsDetailPage() {
  const { slug } = useParams();
  const news = newsDetails[slug];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [slug]);

  if (!news) {
    return (
      <Navigate
        to="/art"
        replace
      />
    );
  }

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const shareUrl = window.location.href;
  const shareText = encodeURIComponent(news.title);

  return (
    <main className="news-detail">
      {/* Breadcrumb */}
      <nav className="breadcrumb">
        <Link to="/art">Trang chủ</Link> / <Link to="/art/news">Tin tức</Link> /{" "}
        <span>{news.title}</span>
      </nav>

      <article className="news-detail__container">
        <h1 className="news-detail__title">{news.title}</h1>

        <div className="news-detail__meta">
          <span>
            <FaClock /> {news.date}
          </span>
          <span>
            <FaUser /> {news.author}
          </span>
          <span>
            <FaFolder /> {news.category}
          </span>
          <span>
            <FaTags /> {news.tags.join(", ")}
          </span>

          {/* Share Buttons */}
          <div className="news-detail__share">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                shareUrl
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chia sẻ lên Facebook"
            >
              <FaShareAlt />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                shareUrl
              )}&text=${shareText}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chia sẻ lên Twitter"
            >
              <FaShareAlt />
            </a>
            <a
              href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                shareUrl
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chia sẻ lên LinkedIn"
            >
              <FaShareAlt />
            </a>
          </div>
        </div>

        <div className="news-detail__image-wrapper">
          <img
            src={news.image}
            alt={news.title}
            className="news-detail__image"
          />
        </div>

        <p className="news-detail__summary">{news.summary}</p>

        <div
          className="news-detail__content"
          dangerouslySetInnerHTML={{ __html: news.content }}
        />

        {news.imagesGallery && news.imagesGallery.length > 0 && (
          <section className="news-detail__gallery">
            <h2>Thư viện ảnh</h2>
            <div className="news-detail__gallery-list">
              {news.imagesGallery.map(({ src, caption }, idx) => (
                <figure
                  key={idx}
                  className="news-detail__gallery-item"
                >
                  <img
                    src={src}
                    alt={caption}
                  />
                  <figcaption>{caption}</figcaption>
                </figure>
              ))}
            </div>
          </section>
        )}

        {news.relatedNews && news.relatedNews.length > 0 && (
          <section className="news-detail__related">
            <h2>Bài viết liên quan</h2>
            <div className="news-detail__related-cards">
              {news.relatedNews.map(({ slug, title, image }) => (
                <Link
                  key={slug}
                  to={`/art/news/${slug}`}
                  className="news-detail__related-card"
                >
                  <img
                    src={image}
                    alt={title}
                  />
                  <p>{title}</p>
                </Link>
              ))}
            </div>
          </section>
        )}
      </article>

      <button
        className="back-to-top"
        onClick={handleBackToTop}
        aria-label="Quay lên đầu trang"
      >
        <FaArrowUp />
      </button>
    </main>
  );
}

export default NewsDetailPage;
